module.exports = __webpack_public_path__ + "img/dropdown-icon.99ea8706.svg";